import { usePrefs } from "@/context/PrefsContext";

const BASE = process.env.REACT_APP_BACKEND_URL;

export function Mascot({ m, size = 120, message = true, className = "", testid = "mascot" }) {
  const { lang } = usePrefs();
  if (!m) return null;
  return (
    <div data-testid={testid} data-mascot={m.code} className={`flex items-center gap-4 ${className}`}>
      <img src={`${BASE}${m.image}`} alt={m.label_id} width={size} height={size} className="shrink-0 rounded-2xl object-cover mascot-pop" style={{ width: size, height: size }} data-testid={`${testid}-image`} />
      {message && (
        <div className="min-w-0">
          <p className="font-jpserif text-lg leading-tight" data-testid={`${testid}-label`}>{lang === "jp" ? m.label_jp : m.label_id}</p>
          <p className="mt-1 text-sm text-muted-foreground" data-testid={`${testid}-message`}>{lang === "jp" ? m.msg_jp : m.msg_id}</p>
          <p lang="ja" className="jp mt-0.5 text-xs text-muted-foreground/70">{lang === "jp" ? m.msg_id : m.msg_jp}</p>
        </div>
      )}
    </div>
  );
}
